module.exports = __webpack_public_path__ + "media/images/products/shop/5-7f27e32b32dabddfbf86d30c501e165f.jpg";